import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaFacebookF,
  FaWhatsapp,
} from "react-icons/fa";
import { SiX } from "react-icons/si";
import BannerAds from "./BannerAds";

// SOCIAL LINKS
const socialLinks = [
  { href: "https://x.com/vinodkumar_mk9", label: "X", color: "#fff", type: "x" },
  {
    href: "https://www.linkedin.com/in/vinod-kumar-mk-2712023bb",
    label: "LinkedIn",
    color: "#0a66c2",
    type: "li",
  },
  {
    href: "https://www.instagram.com/theblogssphere/",
    label: "Instagram",
    color: "#e1306c",
    type: "ig",
  },
  
  {
    href: "https://www.facebook.com/profile.php?id=61576476816780",
    label: "Facebook",
    color: "#1877f2",
    type: "fb",
  },
  
  {
    href: "https://whatsapp.com/channel/0029VbC0RlaHFxOszisxPs1Z",
    label: "WhatsApp",
    color: "#25d366",
    type: "wa",
  },
  {
    href: "http://www.youtube.com/@TheblogsSphere",
    label: "YouTube",
    color: "#ff0000",
    type: "yt",
  },
];

// QUICK LINKS
const quickLinks = [
  { to: "/home", label: "🏠 Home" },
  { to: "/blogs", label: "📖 Read Blogs" },
  { to: "/add-blog", label: "✍️ Write Blog" },
  { to: "/leaderboard", label: "🏆 Leaderboard" },
  { to: "/pro", label: "👤 Profile" },
  { to: "/terms", label: "📄 Terms & Conditions" },
  { to: "/privacy", label: "🔒 Privacy Policy" },
];

// ICON SWITCH
const SocialIcon = ({ type }) => {
  if (type === "x") return <SiX size={18} />;
  if (type === "li") return <FaLinkedin size={18} />;
  if (type === "ig") return <FaInstagram size={18} />;
  if (type === "yt") return <FaYoutube size={18} />;
  if (type === "fb") return <FaFacebookF size={18} />;
  if (type === "wa") return <FaWhatsapp size={18} />;
  return null;
};

const Footer = () => {
  return (
    <footer className="footer">
      {/* GLOW ORBS */}
      <div className="footer-orb orb-left" />
      <div className="footer-orb orb-right" />
   <BannerAds/>
      <div className="footer-container">
        {/* BRAND */}
        <div className="footer-section brand-section">
          
          <div className="footer-logo">
            <span className="logo-the">The</span>
            <span className="logo-blogs">Blogs</span>
            <span className="logo-sphere">Sphere</span>
          </div>

          <p className="brand-desc">
            A blogging world where creators share ideas, knowledge, and
            experiences. Discover trending articles, follow authors, and grow
            together.
          </p>

          <div className="brand-tag">
            🌐 Knowledge · Community · Growth
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="footer-link">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-section">
          <h3 className="footer-heading">Contact Us</h3>
          <div className="contact-list">
            <div className="contact-item">
              <span className="contact-icon">📧</span>
              <span>theblogssphere@gmail.com</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <span>+91 8095996203</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>Bangalore, India</span>
            </div>
          </div>
        </div>

        {/* SOCIAL */}
        <div className="footer-section social-section">
          <h3 className="footer-heading">Follow Us</h3>
          <p className="social-sub">Stay connected with our community</p>

          <div className="social-icons">
            {socialLinks.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn"
                title={s.label}
                style={{
                  "--s-color": s.color,
                }}
              >
                <SocialIcon type={s.type} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* DIVIDER */}
      <div className="footer-divider">
        <span className="divider-line" />
        <span className="divider-icon">✦</span>
        <span className="divider-line" />
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} TheBlogsSphere · All Rights Reserved
        </p>
        <p>
          Crafted with <span className="heart">❤️</span> by{" "}
          <span className="dev-name">VINOD KUMAR M K </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;